import api from './config';

export const getRoles          = ()            => api.get('/roles').then(r => r.data);
export const getRoleById       = (id)          => api.get(`/roles/${id}`).then(r => r.data);
export const getAllPermissions  = ()            => api.get('/roles/permissions/all').then(r => r.data);
export const createRole        = (data)        => api.post('/roles', data).then(r => r.data);
export const updateRole        = (id, data)    => api.put(`/roles/${id}`, data).then(r => r.data);
export const updateRolePerms   = (id, ids)     => api.put(`/roles/${id}/permissions`, { permissionIds: ids }).then(r => r.data);
export const deleteRole        = (id)          => api.delete(`/roles/${id}`).then(r => r.data);
export const customizeRole     = (id)          => api.post(`/roles/customize/${id}`).then(r => r.data);
